import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccessRestrictionDialogComponent } from '../components/access-restriction-dialog/access-restriction-dialog.component';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private location: Location) { }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action,{
      duration: 3000
    });
  }

  openDialogBox(message: string,returnBack:boolean) {
    const dialogRef = this.dialog.open(AccessRestrictionDialogComponent, {
      data: { mes: message } 
    });
    dialogRef.afterClosed().subscribe(result => {
      if ((result === 'ok') && (returnBack === true)){
        this.location.back();
      }
    });
  }
}